import dayjs from "dayjs";

import {
  VersionCheck,
  VersionIsCurrent,
  VersionOutOfDate
} from "~/redux/actions/version";

type Actions = VersionCheck | VersionIsCurrent | VersionOutOfDate;

export type VersionState = {
  lastCheckedTime: number;
  debounceInProgress: boolean;
};

export const initialState = {
  lastCheckedTime: dayjs().unix(),
  debounceInProgress: false
};

const reducer = (
  state: VersionState | undefined,
  action: Actions
): VersionState => {
  if (state === undefined) {
    return initialState;
  }
  switch (action.type) {
    case "version/IS_CURRENT":
      return {
        ...state,
        lastCheckedTime: dayjs().unix()
      };
    case "version/OUT_OF_DATE":
      return {
        ...state,
        debounceInProgress: true
      };
    case "version/CHECK":
    default:
      return state;
  }
};

export const version = reducer;
